import NavBar from "./NavBar";
import { Outlet } from 'react-router-dom'
import Footer from "./Footer";

export default function Template() {
  return (
    <>
      <NavBar />
      <Outlet />
      <Footer />
    </>
  )
}